import Booking from "./Booking";
import Testimonials from "./Testimonials";
import GrandPremiumRoom from "./RoomSLider/GrandPremiumRoom.js";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/OwlCarousel.js';
import 'react-owl-carousel2/lib/styles.css';
export default function Accomodations() {

    const options = {
        items: 1,
        nav: true,
        dots:true,
        rewind: true,
        autoplay: true,
        loop: true,
        center:true,
        margin:0
    };

    return (
      <>
      <div className="rooms-page" id="rooms-page">
    
        <section className="inner-banner-area rooms-hero">
          <img src="img/room-hero-banner.avif" className="w-100" />
          <div className="container">
            <div className="contact-banner">
                <div className="text-center">
                <h2 className="inner-banner-heading">Accomodation</h2>
                <nav aria-label="breadcrumb" className="banner-breadcrumb">
                    <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="index.php">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Accomodation</li>
                    </ol>
                </nav>
                </div>
            </div>
            </div>
        </section>

        <Booking></Booking>


        <section className="section-margin section-margin--small">
    <div className="container">
        <div className="section-intro text-center pb-80px">
            <h1 className="inner-section-main-heading">Explore Our Rooms</h1>
        </div>

        <div className="row pb-4">
            <div className="col-md-6 col-xl-6 mb-5">
                <div className="card card-explore">
                    <div className="rooms-slider text-center">
                        <OwlCarousel options={options} >
                            <div>
                                    <div className="card-explore__img">
                                        <img className="card-img" src="../img/grand-premium-room.avif" alt="" />
                                    </div>
                                </div>
                            </OwlCarousel>
                    </div>
                    <div className="card-body">
                        <h4 className="card-explore__title"><a href="#">Grand Premium Rooms</a></h4>
                        <p>
                            The Grand New Delhi offers rooms of quality design and abundant extravaganza to amaze you. These luxury hotel rooms near Delhi airport provide ultra comfort and are designed for an ideal stay in the city. The
                            Grand consists of hospitality services that always add to the magnificence of your stay and make The Grand one of the finest 5-star hotels in New Delhi.
                        </p>
                        <input type="checkbox" className="check" />

                        <div className="text-box-btns-1">
                            <a href="#" className="btn book-now-hero-1" id="book-now">Book Now</a>
                            <a href="#" className="btn explore-more-hero-1">Explore More</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 col-xl-6 mb-5">
                <div className="card card-explore">
                    <div className="rooms-slider text-center">
                    <OwlCarousel options={options} >
                            <div>
                                    <div className="card-explore__img">
                                        <img className="card-img" src="../img/grand-club-rooms.avif" alt="" />
                                    </div>
                                </div>
                                <div>
                                    <div className="card-explore__img">
                                        <img className="card-img" src="../img/grand-premium-room.avif" alt="" />
                                    </div>
                                </div>
                            </OwlCarousel>
                        
                    </div>
                    <div className="card-body">
                        <h4 className="card-explore__title"><a href="#">Grand Club Rooms</a></h4>
                        <p>
                            Designed keeping in mind the requirement of today’s busy traveler, Grand Club Rooms are a perfect blend of luxury and comfort with distinctive guest amenities. Crafted with plush wooden interiors, the Grand Club
                            Rooms are one of the most luxurious Delhi hotel rooms. The Grand Club rooms are on a separate floor and come with exclusive access to The Grand Club offering private check-in and check-out, dedicated concierge
                            service, and other personalized benefits. Book your luxurious retreat at one of the best hotels near New Delhi airport.
                        </p>
                        <input type="checkbox" className="check" />

                        <div className="text-box-btns-1">
                            <a href="#" className="btn book-now-hero-1" id="book-now">Book Now</a>
                            <a href="#" className="btn explore-more-hero-1">Explore More</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 col-xl-6 mb-5">
                <div className="card card-explore">
                    <div className="rooms-slider text-center">
                    <OwlCarousel options={options} >
                    <div>
                                    <div className="card-explore__img">
                                    <img className="card-img" src="../img/business-suite.avif" alt="" />
                                    </div>
                                </div>
                        
                    </OwlCarousel>
                        
                    </div>
                    <div className="card-body">
                        <h4 className="card-explore__title"><a href="#">Business Suites</a></h4>
                        <p>
                            Experience sheer luxury amidst contemporary furnishings of our business suites in Vasant Kunj that come with a master bedroom, living area and spacious bathroom; designed for the business traveler of today’s
                            times. The living room attached to the master bedroom of these business suites in Vasant Kunj is ideal for small business meetings or unwinding with friends and family. While staying in these rooms at our
                            business hotel in Delhi, enjoy access to The Grand Club Lounge with exclusive benefits. We ensure an unparalleled luxury, which makes us one of the best 5-star hotels in New Delhi.
                        </p>
                        <input type="checkbox" className="check" />

                        <div className="text-box-btns-1">
                            <a href="#" className="btn book-now-hero-1" id="book-now">Book Now</a>
                            <a href="#" className="btn explore-more-hero-1">Explore More</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 col-xl-6 mb-5">
                <div className="card card-explore">
                    <div className="rooms-slider text-center">
                    <OwlCarousel options={options} >
                    <div>
                                    <div className="card-explore__img">
                                    <img className="card-img" src="img/executive-suite.avif" alt="" />
                                    </div>
                                </div>
                        
                    </OwlCarousel>
                        
                    </div>
                    <div className="card-body">
                        <h4 className="card-explore__title"><a href="#">Executive Suites</a></h4>
                        <p>
                            An ideal combination of contemporary and classic styles with hued interiors that exemplify luxurious living, the magnificent Executive Suites in Vasant Kunj, offer a picturesque view of the city. Our business
                            hotel near IGI Airport, New Delhi, offers executive suites that come with a lavish master bedroom with a sitting area, living room, stylish bathroom, and a guest powder room to make your stay in Delhi a
                            comfortable one.
                        </p>
                        <input type="checkbox" className="check" />

                        <div className="text-box-btns-1">
                            <a href="#" className="btn book-now-hero-1" id="book-now">Book Now</a>
                            <a href="#" className="btn explore-more-hero-1">Explore More</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 col-xl-6 mb-5">
                <div className="card card-explore">
                    <div className="rooms-slider text-center">
                    <OwlCarousel options={options} >
                    <div>
                                    <div className="card-explore__img">
                                    <img className="card-img" src="img/deluxe-suite-room.avif" alt="" />
                                    </div>
                                </div>
                        
                    </OwlCarousel>
                        
                    </div>
                    <div className="card-body">
                        <h4 className="card-explore__title"><a href="#">Deluxe Suites</a></h4>
                        <p>
                            An oasis of luxury, the deluxe suites in Delhi, situated on the top floor of our hotel, feature a beautifully appointed master bedroom with en-suite bathroom, a living room, dining room, guest powder room
                            personal butler service on a requirement. Great attention has been paid to even minutest details, ensuring your stay at our luxury hotel in Vasant Kunj is a truly unique experience. The master bedroom looks
                            marvellous with premium carpet flooring, aesthetic artefacts, comfortable king-size bed with fine linen and thoughtful modern amenities. The living area comes with a couch, a coffee table and a writing desk. This
                            category of suites come with exclusive benefits of The Grand Club Lounge. Enjoy a resplendent stay at one of the best business hotels near IGI Airport and experience the real luxury.
                        </p>
                        <input type="checkbox" className="check" />

                        <div className="text-box-btns-1">
                            <a href="#" className="btn book-now-hero-1" id="book-now">Book Now</a>
                            <a href="#" className="btn explore-more-hero-1">Explore More</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 col-xl-6 mb-5">
                <div className="card card-explore">
                    <div className="rooms-slider text-center">
                    <OwlCarousel options={options} >
                    <div>
                                    <div className="card-explore__img">
                                    <img className="card-img" src="img/presidential-suite-room.avif" alt="" />
                                    </div>
                                </div>
                        
                    </OwlCarousel>

                        
                    </div>
                    <div className="card-body">
                        <h4 className="card-explore__title"><a href="#">Presidential Suite</a></h4>
                        <p>
                            Opulence redefined The Presidential Suite in New Delhi exudes immaculate luxury and warmth. The suite is well complemented by a lavish bedroom, extensive living and dining spaces, a powder room, a private bar and
                            a fully equipped pantry serviced by the personal butler.<br />
                            Stay in Delhi in pure luxury, the master bedroom has a lavish bathroom attached to it with deluxe amenities, shower cubicles, silk bathrobes and more.<br />
                            Unparalleled care has been taken to provide the best of amenities like a complimentary bottle of champagne, chocolates, fresh flowers, fruit platter, cheese platter and special pillow menu.<br />
                            This premium suite in New Delhi offers a rapturous ambience combined with impeccable extravagantly decked interiors. Book your stay at our Business hotels near IGI airport and enjoy our offerings of luxury.
                        </p>
                        <input type="checkbox" className="check" />

                        <div className="text-box-btns-1">
                            <a href="#" className="btn book-now-hero-1" id="book-now">Book Now</a>
                            <a href="#" className="btn explore-more-hero-1">Explore More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</div>

<Testimonials></Testimonials>

      </>
    );
  }
  